import { WidgetsToPathMapType } from "shared/types";

// will be deleted when we move to fetch json
export const widgetToJsonPath = {
  questionnaire: "/assets/data/configurations/questionnaire/questionnaire.json",
  passwordmanager:
    "/assets/data/configurations/passwordmanager/passwordmanager.json",
};

export const widgetsToPathMap: WidgetsToPathMapType = {
  questionnaire: () => import("widgets/onboarding/questionnaire"),
  passwordmanager: () => import("widgets/passwordmanager"),
  updatephonenumber: () => import("widgets/updatephonenumber"),
};
